import type { DeepReadonly } from "ts-essentials";

import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Union } from "@/__main__/data-model.mjs";
import { MEMBERSHIP_TYPE } from "@/game-destiny2/constants/membership-types.mjs";

const membershipModel = {
  membershipId: String,
  membershipType: Union(Object.values(MEMBERSHIP_TYPE)),
} satisfies ModelDefinition;

export const userProfileModel = {
  blitzUser: Boolean,
  bungieId: String,
  bungieName: String,
  bungieNameCode: Number,
  iconPath: String,
  memberships: [membershipModel],
} satisfies ModelDefinition;

export const UserProfileModel = createModel({
  data: { bungieProfile: userProfileModel },
}).transform(userProfileModel, (data) => data.data.bungieProfile);

export type UserProfile = DeepReadonly<FromModel<typeof userProfileModel>> & {
  steam3?: number;
};
